import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { withRouter } from "../../../withRouter";
import logo from "../../website/home/assets/img/givbeeLogo.png";
import store from "../../../redux/store";
import PtsAlert from "../../../component/givBee/ptsAlert/PtsAlert";
import AdminAppUserDataAction from "../../../redux/adminPanel/appUserData/AdminAppUserDataAction";
import AdminHeaderAction from "../../../redux/adminPanel/header/AdminHeaderAction";
import AdminStaticDataAction from "../../../redux/adminPanel/staticData/AdminStaticDataAction";
import {
  ApResentOTP_Url,
  ApStatic_Url,
  ApVerifyOTP_Url,
} from "../../../provider/ServiceUrl";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";

export class AdminVerifyOTP extends Component {
  header = store.getState().adminHeader.adminHeader;
  constructor(props) {
    super(props);
    this.state = {
      verifyOtp: "",
      value1: "",
      value1Ref: React.createRef(),
      value2: "",
      value2Ref: React.createRef(),
      value3: "",
      value3Ref: React.createRef(),
      value4: "",
      value4Ref: React.createRef(),
      value5: "",
      value5Ref: React.createRef(),
      value6: "",
      value6Ref: React.createRef(),
      render: false,
    };
  }

  componentDidMount() {
    this.state.value1Ref.current?.focus();
  }

  handleValueChange = async (e) => {
    const { name, value } = e.target;

    if (e.key === "Backspace") {
      return;
    }
    if (value.length > 1) {
      PtsAlert.error("Please enter a single digit");
      return;
    }

    await this.setState({ [name]: value });

    switch (name) {
      case "value1":
        this.value2Focus();
        this.value2Select();
        break;
      case "value2":
        this.value3Focus();
        this.value3Select();
        break;
      case "value3":
        this.value4Focus();
        this.value4Select();
        break;
      case "value4":
        this.value5Focus();
        this.value5Select();
        break;
      case "value5":
        this.value6Focus();
        this.value6Select();
        break;
      case "value6":
        this.verifyOTPInBackend();
        break;
      default:
        break;
    }
  };

  handleKeyUp = (e) => {
    const { name, key } = e.target;
    if (key === "Enter") {
      this.verifyOTPInBackend();
    } else if (key === "ArrowLeft") {
      const map = {
        value2: this.value1Ref,
        value3: this.value2Ref,
        value4: this.value3Ref,
        value5: this.value4Ref,
        value6: this.value5Ref,
      };
      if (map[name]) map[name].current.focus();
    } else if (key === "ArrowRight") {
      const map = {
        value1: this.value2Ref,
        value2: this.value3Ref,
        value3: this.value4Ref,
        value4: this.value5Ref,
        value5: this.value6Ref,
      };
      if (map[name]) map[name].current.focus();
    }
  };

  handleKeyDown = (e) => {
    if (e.key !== "Backspace") return;

    e.preventDefault();
    const { name, value } = e.target;

    const prevMap = {
      value2: this.state.value1Ref,
      value3: this.state.value2Ref,
      value4: this.state.value3Ref,
      value5: this.state.value4Ref,
      value6: this.state.value5Ref,
    };

    if (!value) {
      const prev = prevMap[name];
      if (prev?.current) {
        prev.current.focus();
      }
      return;
    }

    this.setState({ [name]: "" });
  };


  value1Focus = () => {
    this.state.value1Ref.current.focus();
  };
  value2Focus = () => {
    this.state.value2Ref.current.focus();
  };
  value3Focus = () => {
    this.state.value3Ref.current.focus();
  };
  value4Focus = () => {
    this.state.value4Ref.current.focus();
  };
  value5Focus = () => {
    this.state.value5Ref.current.focus();
  };
  value6Focus = () => {
    this.state.value6Ref.current.focus();
  };

  value1Select = () => {
    this.state.value1Ref.current.select();
  };
  value2Select = () => {
    this.state.value2Ref.current.select();
  };
  value3Select = () => {
    this.state.value3Ref.current.select();
  };
  value4Select = () => {
    this.state.value4Ref.current.select();
  };
  value5Select = () => {
    this.state.value5Ref.current.select();
  };
  value6Select = () => {
    this.state.value6Ref.current.select();
  };

  renderInputBox = (name, ref) => {
    return (
      <Col md={2} style={{ padding: "0rem 1rem 0rem 0rem" }}>
        <input
          type="number"
          autoFocus={true}
          ref={this.state[ref]}
          className="form-control otpFormControlInput"
          id={"otpFormControlInput-" + name}
          maxLength="1"
          name={name}
          value={this.state[name]}
          onKeyUp={this.handleKeyUp}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleValueChange}
          aria-describedby="defaultFormControlHelp"
        />
      </Col>
    );
  };

  verifyOTPInBackend() {
    const { value1, value2, value3, value4, value5, value6 } = this.state;

    const otpValue = `${value1}${value2}${value3}${value4}${value5}${value6}`;

    if (otpValue.length !== 6) {
      return;
    }
    const postObject = {
      header: this.header,
      otp: otpValue,
    };
    AdminFetchServerData.callPostService(ApVerifyOTP_Url, postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          let appuser = output.appuser;
          store.dispatch(
            AdminAppUserDataAction.setAdminUser(appuser)
          );
          this.processLoginSuccess(output);
          if (appuser.isRememberMe) {
            localStorage.setItem("apRememberMe", appuser.isRememberMe);
            localStorage.setItem("apHeader", JSON.stringify(this.header));
          }
        } else {
          if (
            response.message &&
            response.message.includes("Your account is locked")
          ) {
            this.props.navigate("/ApLogin");
          }
        }
      }
    );
  }

  async setAdminStaticData(header) {
    const postObject = {
      header: header,
    };

    AdminFetchServerData.callPostService(ApStatic_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          store.dispatch(AdminStaticDataAction.setAdminStaticData(output.data));
        }
      }
    );
  }

  async processLoginSuccess(output_data) {
    let headerObj = this.header;
    store.dispatch(AdminHeaderAction.setAdminHeader(headerObj));
    await this.setAdminStaticData(headerObj);
    let menus = output_data.appuser.profile.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    for (const menu of menus) {
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }

  ResendVerifyOTP() {
    const postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(ApResentOTP_Url, postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          PtsAlert.success(response.message);
          this.state.value1Ref.current.focus();
          this.setState({
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            value5: "",
            value6: "",
          });
        }
      }
    );
  }
  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center apLeftBackground">
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <ValidatorForm
                className="text-start"
                ref="form"
                id="formAuthentication"
                onSubmit={this.verifyOTPInBackend.bind(this)}
              >
                <div className="signinHeding">Account Verification</div>
                <div className="mb-4 mt-4">
                  <label className="form-label" htmlFor="multiStepsPass">
                    Enter Verification Code
                  </label>
                  <Row style={{ margin: "0.6em 0em" }}>
                    {this.renderInputBox("value1", "value1Ref")}
                    {this.renderInputBox("value2", "value2Ref")}
                    {this.renderInputBox("value3", "value3Ref")}
                    {this.renderInputBox("value4", "value4Ref")}
                    {this.renderInputBox("value5", "value5Ref")}
                    {this.renderInputBox("value6", "value6Ref")}
                  </Row>
                </div>
                <NavLink
                  className="naveLink"
                  onClick={this.ResendVerifyOTP.bind(this)}
                  style={{ float: "right", marginBottom: "10px" }}
                >
                  <span>Resend Code</span>
                </NavLink>
                <button className="goButton d-grid w-100" type="submit">
                  {" "}
                  Next
                </button>
                <div className="d-flex flex-row pt-3">
                  <NavLink className="pt-1" to="/ApLogin">
                    <ArrowBackIosNewIcon />
                    Back
                  </NavLink>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AdminVerifyOTP);
